<button
  class="btn btn-item justify-start"
  [class.cursor-default]="setDisablingToPreviousButton"
  [ngStyle]="{ width: buttonWidth + 'px' }"
  [disabled]="setDisablingToPreviousButton"
  (click)="prev()"
>
  <svg-icon class="transform rotate-180" [src]="'open-arrow-icon'"></svg-icon>
</button>
<div class="carousel-wrap" [ngStyle]="carouselWrapperStyles">
  <ul #carouselInner class="carousel-inner-container" [ngStyle]="{ columnGap: columnGap ? columnGap + 'px' : '' }">
    @if (currentWrapperWidth) {
      @for (slide of slides; track $index) {
        <li #slideItem class="slide-container">
          <ng-template [ngTemplateOutlet]="slide.template"></ng-template>
        </li>
      }
    }
  </ul>
</div>
<button
  class="btn btn-item justify-end"
  [class.cursor-default]="setDisablingToNextButton"
  [ngStyle]="{
    'margin-left': columnGap ? -columnGap + 'px' : '',
    width: buttonWidth + 'px',
  }"
  [disabled]="setDisablingToNextButton"
  (click)="next()"
>
  <svg-icon [src]="'open-arrow-icon'"></svg-icon>
</button>
